import catalogTrackerSkuDetails from "./catalog-tracker-sku-details.js";

export default catalogTrackerSkuDetails;
